(() => {
  if (customElements.get('list-carousel-accent')) {
    return;
  }

  class ListCarouselAccent extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        updateOnMove: true,
        drag: false,
        perPage: 1,
        padding: { right: 450 },
        gap: 115,
        height: 612,
        arrows: true,
        pagination: false,
        breakpoints: {
          1300: {
            padding: { left: 0, right: 220 },
          },
          1023: {
            gap: 20,
            padding: { left: 200, right: 200 },
            drag: true,
            height: 612
          },
          767: {
            gap: 20,
            padding: { left: 100, right: 100 },
            drag: true,
            height: 560
          },
          480: {
            gap: 20,
            padding: { left: 90, right: 90 },
            drag: true,
            height: 255
          }
        }
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.slider = new Splide(this,this.options).mount();

      this.accentCarousel = this.closest('section').querySelector('accent-carousel');
      if(!this.accentCarousel) return;

      this.slider.on('active', (data) => {
        this.accentCarousel.slider.go(data.index);
      });
    }
  }

  customElements.define('list-carousel-accent', ListCarouselAccent);
})();
